module.exports = __webpack_public_path__ + "img/w27-cover.ffe57d4e.jpg";